import React from 'react';
import Image, { StaticImageData } from 'next/image';

interface IProps {
  title: string;
  instructionsImage: StaticImageData;
  beforeImage: StaticImageData;
  afterImage: StaticImageData;
  displayImageWidth: number;
  displayImageHeight: number;
}

export default function Example(props: IProps) {
  return (
    <div>
      <h1 className="my-2 mb-6 w-full px-5 text-center text-3xl font-bold leading-tight text-gray-800">
        {props.title}
      </h1>
      <div className="bordered w-full border border-solid border-gray-100 p-6">
        <Image alt="instructions image" src={props.instructionsImage} />
      </div>
      <div className="flex flex-wrap">
        <div className="bordered w-full border border-solid border-gray-100 p-6 sm:w-1/2">
          <Image alt="before image" src={props.beforeImage} />
        </div>
        <div className="bordered w-full border border-solid border-gray-100 p-6 sm:w-1/2">
          <Image alt="after image" src={props.afterImage} />
        </div>
      </div>
    </div>
  );
}
